// extracted by mini-css-extract-plugin
export var Dropdowns = "style-module--Dropdowns--0e9c1";
export var col = "style-module--col--1e785";
export var dropdownIcon = "style-module--dropdownIcon--d3faa";
export var dropdownItem = "style-module--dropdownItem--9e33a";
export var dropdownText = "style-module--dropdownText--be1ad";
export var dropdownTxt = "style-module--dropdownTxt--b4338";
export var menuCircle = "style-module--menuCircle--b76bb";
export var menuItem = "style-module--menuItem--80da7";
export var subMenuLink = "style-module--subMenuLink--e9507";
export var submenuItem = "style-module--submenuItem--d0181";
export var viewallBtn = "style-module--viewallBtn--6773d";
export var viewallBtnWrap = "style-module--viewallBtnWrap--2317d";